import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NutrienPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        {/* This page appears to just show footer on original site */}
      </main>
      <Footer />
    </div>
  );
};

export default NutrienPage;
